import {lemon, lemonReady} from "../common/lemon";
import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

Swiper.use([Navigation, Autoplay, Pagination]);

let lemonForm;
let lottery_swiper;
lemonReady(function (){
    lemonForm = lemon("#frmLottery");

    //create swiper for lottery header
    lottery_swiper = buildSwiperForLotteryHeader(".lottery-prize-swiper");
    //create swiper for lottery prize content tabs (hidden)
    buildSwiperForLotteryTabs(".lottery-prize-content-swiper");
    lemonForm.find(".lottery-prize-link").on("click", function (e) {
        onLotteryHeaderClick(lemon(this));
        e.preventDefault();
    });
    lemonForm.find(".nav-link").on("click", function (e) {
        toggleTabDisplay(lemon(this));
        e.preventDefault();
    });
    initLotterySlide();
});

function initLotterySlide(){
    let def_slide_idx;
    //let def_slide = lemonForm.find(".lottery-prize-swiper").find(".default-selection");
    let def_slides = document.querySelectorAll(".default-selection");
    for(let def_elem of def_slides){
         def_slide_idx = parseInt(def_elem.getAttribute("data-swiper-slide-index"));
        console.log("initLotterySlide def_slide_idx = " + def_slide_idx);
    }
    lottery_swiper.slideToLoop(def_slide_idx);
    onLotteryHeaderSlideChange(def_slide_idx);
    lottery_swiper.autoplay.start();
}
function onLotteryHeaderSlideChange(def_slide_idx){
    lemonForm.find(".lottery-prize-swiper").find(".swiper-slide").removeClass("my-active-slide");
    /*for some reasons the realIndex does not work anymore in this swiper version, hikica.jp's is working */
    //console.log("onLotteryHeaderSlideChange realIndex = " + lottery_swiper.realIndex);
    //console.log("onLotteryHeaderSlideChange activeIndex = " + lottery_swiper.activeIndex);
    //let realIndex = lottery_swiper.realIndex;
    let target_slide = lemonForm.find(".lottery-prize-swiper").find('[data-swiper-slide-index="' + def_slide_idx +'"]');
    target_slide.addClass("my-active-slide");
    let target_id = target_slide.find(".lottery-prize-link").data("target_id");
    const targetElem = document.getElementById(target_id);
    targetElem.click();
    //lemon("#" + target_id).trigger("click");
    if(target_slide.hasClass("completed")){
        lemon("#nav-tabContent").addClass("completed");
    }else{
        lemon("#nav-tabContent").removeClass("completed");
    }
}
function onLotteryHeaderClick(header){
    lemonForm.find(".lottery-prize-swiper").find(".swiper-slide").removeClass("my-active-slide");
    header.closest(".swiper-slide").addClass("my-active-slide");
    let target_id = header.data("target_id");
    const targetElem = document.getElementById(target_id);
    targetElem.click();
    //lemon("#" + target_id).trigger("click");
    if(header.closest(".swiper-slide").hasClass("completed")){
        lemon("#nav-tabContent").addClass("completed");
    }else{
        lemon("#nav-tabContent").removeClass("completed");
    }
}
function toggleTabDisplay(srcElem){
    lemonForm.find(".nav-link").removeClass("active");
    srcElem.addClass("active");
    lemon("#nav-tabContent").find(".tab-pane").removeClass("active");
    let targetId = srcElem.data("target");
    lemon(targetId).addClass("active");
}

function buildSwiperForLotteryHeader(target_selector){
    return new Swiper(target_selector, {
        slidesPerView: 2,
        spaceBetween: 2,
        grabCursor: true,
        centeredSlides: false,
        autoplay: {
            enabled: true,
            delay: 3000,
            disableOnInteraction: false,
        },
        direction: "horizontal",
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        showSwitchArrows: false,
        loop: true,
        pagination:{
            el: '.swiper-pagination', dynamicBullets: true
        },
        breakpoints: {
            761: {
                slidesPerView: 5,
                spaceBetween: 2,
                showSwitchArrows: true,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    enabled: true,
                    delay: 3000,
                    disableOnInteraction: false,
                },
            }
        }
    });
}
function buildSwiperForLotteryTabs(target_selector){
    return new Swiper(target_selector, {
        slidesPerView: 5,
        spaceBetween: 0,
        loop: true,
        autoplay: {
            enabled: true,
            delay: 1000,
        },
    });
}